export let skp_plans_F = {
  1: 77,
};

export let skp_plans_B = {
  5: 71,
  10: 72,
  20: 73,
  99: 74,
};

export let sam_plans = {
  1: 80,
};

export let skp_plans = {
  1: 77,
  5: 71,
  10: 72,
  20: 73,
  99: 74,
};
